import React from 'react';
import { Link } from 'react-router-dom';
import { Car, Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react';
import { BUSINESS_INFO, OPENING_HOURS, NAV_LINKS } from '../../utils/constants';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialMediaLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/profile.php?id=61581426567365', // Replace with your Facebook page URL
      icon: '/assets/images/facebook.png',
      alt: 'Facebook'
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/ara_mobilevaleting?igsh=MXNhcG5sbmJmZW9jNw==', 
      icon: '/assets/images/instagram.png',
      alt: 'Instagram'
    },
    {
      name: 'TikTok',
      url: 'https://www.tiktok.com/@ara.mobile.valetin?_r=1&_t=ZS-92GzbEZPomt', // Replace with your TikTok profile URL
      icon: '/assets/images/tiktok.png',
      alt: 'TikTok'
    }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img 
                src="/assets/images/logo.png" 
                alt="ARA Mobile Valeting Logo"
                style={{
                  height: '60px',
                  width: 'auto',
                  objectFit: 'contain',
                  filter: 'brightness(0) invert(1)' // Makes logo white for dark footer
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  const carIcon = e.target.nextElementSibling;
                  if (carIcon) carIcon.style.display = 'block';
                }}
              />
              <Car size={32} style={{display: 'none'}} />
              <h3>{BUSINESS_INFO.name}</h3>
            </div>
            <p>
              Professional mobile car valeting services delivering luxury shine to your doorstep. 
            </p>
            <a 
              href={BUSINESS_INFO.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{display: 'inline-block', marginTop: '1rem'}}
            >
              <button className="btn btn-whatsapp">
                <MessageCircle size={16} />
                WhatsApp Us
              </button>
            </a>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
              
              <li style={{marginTop: '1.5rem'}}>
                <div className="social-media-links">
                  {socialMediaLinks.map((social) => (
                    <a
                      key={social.name}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-icon-link"
                      title={social.name}
                    >
                      <img 
                        src={social.icon} 
                        alt={social.alt}
                        className="social-icon"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    </a>
                  ))}
                </div>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Us</h3>
            <ul>
              <li className="flex gap-sm items-center">
                <Phone size={20} />
                <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
                  {BUSINESS_INFO.phoneDisplay}
                </a>
              </li>
              <li className="flex gap-sm items-center">
                <Mail size={20} />
                <a href={`mailto:${BUSINESS_INFO.email}`}>{BUSINESS_INFO.email}</a>
              </li>
              <li className="flex gap-sm items-center">
                <MapPin size={20} />
                <span>{BUSINESS_INFO.address}</span>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Opening Hours</h3>
            <ul>
              <li className="flex gap-sm">
                <Clock size={20} />
                <div>
                  <div style={{fontWeight: 600, color: 'white'}}>{OPENING_HOURS.weekday.days}</div>
                  <div>{OPENING_HOURS.weekday.hours}</div>
                </div>
              </li>
              <li className="flex gap-sm" style={{marginTop: '1rem'}}>
                <Clock size={20} />
                <div>
                  <div style={{fontWeight: 600, color: 'white'}}>{OPENING_HOURS.weekend.days}</div>
                  <div>{OPENING_HOURS.weekend.hours}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} {BUSINESS_INFO.name}. All rights reserved.</p>
          <p>Professional Mobile Car Valeting Services | {BUSINESS_INFO.website}</p>
        </div>
      </div>

    </footer>
  );
};

export default Footer;